import { defineRouting } from "next-intl/routing";

import { Locale } from "@/services/i18n/models/locale";

import { pathnames } from "./pathnames";

export const routing = defineRouting({
  locales: Locale.all,
  defaultLocale: Locale.default,
  localePrefix: {
    mode: "as-needed",
  },
  pathnames,
});
